const R = require('ramda');

export const redirectUrl = url => {
  const newUrl = url.split('/');
  return R.dropLast(newUrl.length > 4 ? 2 : 1, newUrl).join('/');
};



// WEBPACK FOOTER //
// ./src/Detail/redirectUrl/index.js